module.exports = __webpack_public_path__ + "static/media/hipercard.39964c6d.webp";